import { render, staticRenderFns } from "./GoodsCategorySelect.vue?vue&type=template&id=10870d72&scoped=true"
import script from "./GoodsCategorySelect.vue?vue&type=script&lang=ts"
export * from "./GoodsCategorySelect.vue?vue&type=script&lang=ts"
import style0 from "./GoodsCategorySelect.vue?vue&type=style&index=0&id=10870d72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10870d72",
  null
  
)

export default component.exports